import type { IWhInfoColumnProps } from './types';
import styles from './wh-info-column.module.scss';

export const WhInfoColumn: React.FC<IWhInfoColumnProps> = (props) => {
  const { title, children } = props;

  return (
    <div className={styles.column}>
      <h2>{title}</h2>
      {children}
    </div>
  );
};
